<template>
  <v-chip
    label
    class="ma-2 white--text"
    :color="situacaoColor"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <v-icon left>mdi-truck</v-icon>
    {{ text }}
  </v-chip>
</template>

<script>
import { SituacaoEntregaCompra } from 'px-business-components';

export default {
  props: {
    situacao: String,
  },
  computed: {
    mapColor() {
      return {
        PENDENTE: {
          color: 'amber darken-1',
        },
        RECEBIDA: {
          color: 'success',
        },
      };
    },
    situacaoColor() {
      if (!this.situacao) {
        return '';
      }
      return this.mapColor[this.situacao].color;
    },
    text() {
      if (!this.situacao) {
        return '';
      }
      return SituacaoEntregaCompra.keys[this.situacao].description;
    },
  },
};
</script>
